import { create } from 'zustand'

type PostHogLoadedState = {
  isLoaded: boolean
  setLoaded: () => void
}

export const usePostHogLoadedStore = create<PostHogLoadedState>((set) => ({
  isLoaded: false,
  setLoaded: () => set({ isLoaded: true }),
}))
